import React, {lazy, Suspense, useEffect, useState} from "react";
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {isMobile} from "react-device-detect";
import routes from "./routes";
import {unityStore} from "./store/unityStore";
import {authStore} from "./store/authStore";
import {translationStore} from "./store/translationStore";
import {dashboardStore} from "./store/dashboardStore";
import DoubleLogin from "./components/Popups/DoubleLogin";
import Loading from "./components/Loading";
import InviteShowPopup from "./components/Popups/InviteShowPopup";
import ErrorModal from "./components/ModalError";
import RotateDevice from "./components/RotateDevice";
import Mobile from "./containers/mobile";
import ParticipantsPopup from "./components/Popups/ParticipantsPopup";
import InviteToHomeSpace from "./components/Popups/InviteToHomeSpace";
import TransitionRouter from "./components/TransitionRouter";

const UnityLayout = lazy(() => import("./containers/unityLayout"));

const App = observer(() => {
    const {loadUnity} = unityStore;
    const {doubleLogin, inviteMessage} = authStore;
    const {getTranslationData, activeLanguage} = translationStore;
    const {inviteData, clearInviteData} = dashboardStore;
    const [showRotateDevice, setShowRotateDevice] = useState(false);

    useEffect(async () => {
        await getTranslationData();
    }, [activeLanguage]);

    useEffect(() => {
        if (isMobile) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.borderBoxSize) {
                        setShowRotateDevice(entry.borderBoxSize[0].inlineSize > entry.borderBoxSize[0].blockSize);
                    } else {
                        setShowRotateDevice(entry.contentRect.width > entry.contentRect.height);
                    }
                }
            });
            resizeObserver.observe(document.querySelector("#root"))
        }
    }, []);

    return (
        <Suspense fallback={null}>
            <BrowserRouter>
                <TransitionRouter>
                    <Routes>
                        {routes.map((item, index) => (
                            <Route
                                key={index}
                                path={item.path}
                                element={<item.component/>}
                                title={item.title}
                                exact
                            />
                        ))}
                        <Route path="*" element={<Navigate to="/404" replace/>}/>
                    </Routes>
                </TransitionRouter>
                <Suspense fallback={null}>
                    {loadUnity && !isMobile && <UnityLayout/>}
                    {isMobile && <Mobile/>}
                </Suspense>
                {doubleLogin && <DoubleLogin/>}
                {!!inviteMessage && <InviteShowPopup/>}
                {!!inviteData?.sender_user && (
                    <InviteToHomeSpace
                        user={inviteData?.sender_user}
                        roomLink={inviteData?.link}
                        clearData={clearInviteData}
                    />
                )}
                <ParticipantsPopup/>
            </BrowserRouter>
            {showRotateDevice && <RotateDevice/>}
            {!isMobile && <Loading/>}
            <ErrorModal/>
        </Suspense>
    );
});

export default App;

